export interface SchemaHelperWebComponentSchema {
  // all the data needed for rendering
  data: Array<SchemaTable>;
  success: boolean;
}

export interface SchemaTable {
  columns: Array<{
    description: string;
    name: string;
    required: boolean;
    type: string;
  }>;
  description: string;
  name: string;
  platforms: Array<string>;
}

export const HREF_LINK = 'https://www.bitdefender.com/business/support/en/77209-151142-investigating-incidents.html#UUID-0cdbdccf-eb31-3a49-427a-3148b2f90008';

export enum OS {
  WINDOWS = 'windows',
  MAC = 'darwin',
  LINUX = 'linux',
}

export const OS_LABELS = {
  [OS.WINDOWS]: 'Windows',
  [OS.MAC]: 'macOS',
  [OS.LINUX]: 'Linux',
};
